import { render } from "./LandingView.vue?vue&type=template&id=fbdb1a8c"
import script from "./LandingView.vue?vue&type=script&lang=js"
export * from "./LandingView.vue?vue&type=script&lang=js"

import "./LandingView.vue?vue&type=style&index=0&id=fbdb1a8c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__